var map = {
	"./air-nga-en/assets/finger-icon.png": 56583,
	"./ais-tai-en/assets/finger-icon.png": 47118,
	"./ais-tai-tha/assets/finger-icon.png": 14514,
	"./demo-arabic/assets/finger-icon.png": 22106,
	"./demo-et-en/assets/finger-icon.png": 59011,
	"./demo-romanian/assets/finger-icon.png": 69589,
	"./demo-um-en/assets/finger-icon.png": 67034,
	"./dtac-tai-en/assets/finger-icon.png": 35925,
	"./dtac-tai-tha/assets/finger-icon.png": 35087,
	"./ethiotel-et-amh/assets/finger-icon.png": 66809,
	"./ethiotel-et-en/assets/finger-icon.png": 26156,
	"./mtn-cg-fr/assets/finger-icon.png": 35281,
	"./mtn-ci-fr/assets/finger-icon.png": 12383,
	"./mtn-cmr-fr/assets/finger-icon.png": 94331,
	"./mtn-gha-en/assets/finger-icon.png": 42052,
	"./mtn-nga-en/assets/finger-icon.png": 34608,
	"./mtn-zam-en/assets/finger-icon.png": 2010,
	"./saf-ke-en/assets/finger-icon.png": 89323,
	"./saudi-uae-en/assets/finger-icon.png": 45994,
	"./tlk-za-en/assets/finger-icon.png": 61575,
	"./vc-za-en/assets/finger-icon.png": 53307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4471;